import { render, staticRenderFns } from "./RoomTab.vue?vue&type=template&id=07be3c4b&"
import script from "./RoomTab.vue?vue&type=script&lang=js&"
export * from "./RoomTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07be3c4b')) {
      api.createRecord('07be3c4b', component.options)
    } else {
      api.reload('07be3c4b', component.options)
    }
    module.hot.accept("./RoomTab.vue?vue&type=template&id=07be3c4b&", function () {
      api.rerender('07be3c4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/Tabs/RoomTab.vue"
export default component.exports